import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2023-01-16.
 */

export class BenjiKIVSFSUpdateScatterRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;

    //In the case of the 4th scatter that triggers SFS lands on a reel that has enhancer with multiplier it needs to be updated before SFS intro
    public shouldRun():boolean {
        if(BenjiKIV.model.isRestore == false) {
            return (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
                || BenjiKIV.model.sfsIsMoreScatter;
        }
        return false;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._mainTL = gsap.timeline({
            onComplete : () => {
                controller.finish();
            }
        });
        const overlayUpdateTLs:gsap.core.Timeline[] = [];
        let reelIds:number[] = [];
        for(let i:number = 0; i < BenjiKIV.overlayScatterView.activeOverlayScatters.length; i++) {
            //One or two overlays that needs updating
            if(BenjiKIV.overlayScatterView.activeOverlayScatters[i].multiplierValue !== BenjiKIV.model.multiplierScatters[i]) {
                let reelId:number = BenjiKIV.overlayScatterView.activeOverlayScatters[i].overlayPosition.x;
                reelIds.push(reelId);

                const overlayUpdateTL:gsap.core.Timeline = gsap.timeline();
                if (BenjiKIV.model.data.enhancerReel[reelId] == 1){
                    //XSplit
                    overlayUpdateTL.add(gsap.to(BenjiKIV.enhancerView.xSplitXs[reelId].scale, 0.2, {
                        x : 1.4,
                        y : 1.4
                    }));
                    overlayUpdateTL.add(gsap.to(BenjiKIV.enhancerView.xSplitXs[reelId].scale, 0.15, {
                        x : 0.9,
                        y : 0.9
                    }));
                    overlayUpdateTL.add(gsap.to(BenjiKIV.enhancerView.xSplitXs[reelId].scale, 0.1, {
                        x : 1,
                        y : 1
                    }));
                    overlayUpdateTL.add(BenjiKIV.overlayScatterView.activeOverlayScatters[i].getUpdateMultiplierTL(BenjiKIV.model.multiplierScatters[i]), "-=0.1");
                }else{
                    //Multiplier
                    overlayUpdateTL.add(gsap.to(BenjiKIV.enhancerView.multiplierTexts[reelId].scale, 0.2, {
                        x : 1.4,
                        y : 1.4
                    }));
                    overlayUpdateTL.add(gsap.to(BenjiKIV.enhancerView.multiplierTexts[reelId].scale, 0.15, {
                        x : 0.9,
                        y : 0.9
                    }));
                    overlayUpdateTL.add(gsap.to(BenjiKIV.enhancerView.multiplierTexts[reelId].scale, 0.1, {
                        x : 1,
                        y : 1
                    }));
                    overlayUpdateTL.add(BenjiKIV.overlayScatterView.activeOverlayScatters[i].getUpdateMultiplierTL(BenjiKIV.model.multiplierScatters[i]), "-=0.1");
                }
                overlayUpdateTLs.push(overlayUpdateTL);
            }
        }
        const darkOverlaysTLs:gsap.core.Timeline[] = [];
        for(let i:number = 0; i < reelIds.length; i++) {
            let darkOverlayTL:gsap.core.Timeline = gsap.timeline();
            darkOverlayTL.add(() => {
                BenjiKIV.enhancerView.activateDarkOverlay(reelIds[i]);
            }, "+=0.8");
            darkOverlaysTLs.push(darkOverlayTL);
        }
        this._mainTL.add(darkOverlaysTLs);
    }
}